import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { QrcodeStream } from 'vue-qrcode-reader';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';
const callerLogOrigin = 0;
const problemLogOrigin = 1;

export default {
  name: 'JobcardDetail',
  components: {
    TimeComp: require('../../../components/time.vue').default,
    QrcodeStream
  },
  props: ['dataObj'],
  data: function () {
    return {
      jobcardData: { assignedEmployee: '', id: -1 },
      bPortalGis: false,
      element: { name: '' },
      bShowWarning: false,
      bHoursForDuration: false,
      bAssignToEmployee: false,
      bGPSFiltering: false,
      bHasLocation: false,
      bQrCodeScan: false,
      geoLocation: null,
      options: { pageSize: 1000, total: 0, page: 1 },
      selectedReportId: -1,
      newStationId: -1,
      newWorkflowEmployeeId: -1,
      newComment: '',
      newWorkflowEmployee: { name: '' },
      reports: [],
      stations: [],
      elements: [],
      maintenanceActivities: [],
      elementTypeConditions: [],
      workflowEmployees: [],
      complainTypes: [],
      elementTypes: [],
      outcomes: [],
      value: '',
      message: '',
      disabledDates: date => {
        var bDoNotAllow = this.jobcardData ? this.jobcardData.completed : false;
        return bDoNotAllow === true ? bDoNotAllow : date > new Date();
      },
      disabledDatesStart: date => {
        let dte = moment(date);
        let end = moment(this.jobcardData.endDateTime)
        var bDoNotAllow = this.jobcardData ? this.jobcardData.completed : false;

        return bDoNotAllow === true ? bDoNotAllow : date > new Date() || dte.isAfter(end);
      },
      disabledDatesEnd: date => {
        let dte = moment(date);
        let start = moment(this.jobcardData.startDateTime)
        var bDoNotAllow = this.jobcardData ? this.jobcardData.completed : false;

        return bDoNotAllow === true ? bDoNotAllow : date > new Date() || start.isAfter(dte);
      },
      timeFrom: { hours: 0, minutes: 0, descr: 'investigationDetail.TimeFrom', isReadOnly: false },
      timeTo: { hours: 0, minutes: 0, descr: 'investigationDetail.TimeTo', isReadOnly: false },
    }
  },
  computed: {
    jobcardId: function () {
      return this.jobcardData.id;
    },
    mActivityId: function () {
      return this.jobcardData.mActivityId;
    },
    outcomeTypeId: function () {
      return this.jobcardData.outcomeTypeId;
    },
    elementTypeId: function () {
      return this.jobcardData.elementTypeId;
    },
    complainTypeId: function () {
      return this.jobcardData.complainTypeId;
    },
    durationUnit: function () {
      return (this.bHoursForDuration == true ? 'Hours' : 'Minutes');
    },
    timeFromHours: function () {
      return this.timeFrom.hours;
    },
    timeFromMinutes: function () {
      return this.timeFrom.minutes;
    },
    timeToHours: function () {
      return this.timeTo.hours;
    },
    timeToMinutes: function () {
      return this.timeTo.minutes;
    },
    actualDuration: function () {
      if (this.jobcardData.startDateTime == null || this.jobcardData.startDateTime == '' &&
        this.jobcardData.endDateTime == null && this.jobcardData.endDateTime == '')
        return '';

      let start = moment(this.jobcardData.startDateTime).add(this.timeFromHours, 'h').add(this.timeFromMinutes, 'm');
      let end = moment(this.jobcardData.endDateTime).add(this.timeToHours, 'h').add(this.timeToMinutes, 'm');

      return moment.duration(end.diff(start)).asMinutes();
    },
  },
  watch: {
    actualDuration: function (value) {
      this.jobcardData.actualDuration = value;
    },
    bAssignToEmployee: function (value) {
      this.newWorkflowEmployeeId = value === true ? -1 : this.newWorkflowEmployeeId;
      this.newWorkflowEmployee = this.newWorkflowEmployeeId === -1 ? {} : this.newWorkflowEmployee;
    },
    newStationId: function (value) {
      this.getWorkflowEmployees();
    },
    newWorkflowEmployee: function (value) {
      this.newWorkflowEmployeeId = value ? value.id : -1;
    },
    complainTypeId: function (value) {
      this.getMaintenanceActivities();
    },
    mActivityId: function (value) {
      this.getElementTypes();
    },
    outcomeTypeId: function (value) {
      //this.bEnableProblemFound = (value === 1); //ProblemFound
      //this.bEnableNoFurtherProc = (value === 2); //NoFurtherProcessingRequired
      //this.jobcardData.investigationReasonId = (value !== 2) ? -1 : this.jobcardData.investigationReasonId;
    },
    elementTypeId: function (value) {
      this.getElements();
    },
    element: function (value) {
      this.jobcardData.elementId = value ? value.id : -1;
      if (this.$refs.select && this.$refs.select.open)
        this.$refs.select.open = false;
    },
    timeFromHours: function (value) {
      this.jobcardData.dateFromHH = value;
      //this.$root.$emit('investigation_or_jobcard_updated');
    },
    timeFromMinutes: function (value) {
      this.jobcardData.dateFromMin = value;
      //this.$root.$emit('investigation_or_jobcard_updated');
    },
    timeToHours: function (value) {
      this.jobcardData.dateToHH = value;
    },
    timeToMinutes: function (value) {
      this.jobcardData.dateToMin = value;
    },
    bGPSFiltering: function (val) {
      this.getElements();
      if (this.$refs.select)
        this.$refs.select.open = false;
    },
    jobcardId: function (value) {
      if (value <= 0)
        return;
      this.jobcardData.assignedEmployee = this.jobcardData.workflowEmployeeId > 0 ? this.getAssignedWorkflowEmployeeText() : 'Unknown';
      this.bHasLocation = this.jobcardData.hasLocation;

      this.timeFrom.hours = this.jobcardData.dateFromHH;
      this.timeFrom.minutes = this.jobcardData.dateFromMin;
      this.timeTo.hours = this.jobcardData.dateToHH;
      this.timeTo.minutes = this.jobcardData.dateToMin;

      this.getElements();
      this.getStations();
      this.getComplainTypes();
      this.getOutcomes();
      this.getWorkflowEmployees();
      this.getElementTypes();
      this.getProfileDetails();
      this.getJobcardReports();

      this.getElement();

      //this.getMaintenanceActivities();
      this.getElementTypeConditions();

      this.startDateTime = moment(this.jobcardData.startDateTime).subtract(1, 'days').format();
      this.endDateTime = moment(this.jobcardData.endDateTime).subtract(1, 'days').format();
    },
    "jobcardData.endDateTime": function (value) {
      if (moment(value).isBefore(moment(this.jobcardData.startDateTime))) {
        this.$alertMsg(this.$t('common.StartDateBeforeEndDate'), 3);
        this.jobcardData.startDateTime = this.jobcardData.endDateTime;
      }
        
    },
    "jobcardData.startDateTime": function (value) {
      if (moment(value).isAfter(moment(this.jobcardData.endDateTime))) {
        this.$alertMsg(this.$t('common.StartDateBeforeEndDate'), 3);
        this.jobcardData.endDateTime = this.jobcardData.startDateTime;
      }
    },
  },
  created() {
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    var geo = navigator.geolocation.getCurrentPosition(
      (pos) => { this.geoLocation = pos; },
      (err) => { this.$alertMsg(err.message); },
      geoOptions
    );

    if (this.$refs.select)
      this.$refs.select.open = false;

    this.init();
    this.$root.$on('investigation_or_jobcard_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        if (this.dataObj.id > 0)
          this.jobcardData = this.dataObj;
      });
    },
    cancelNewEmployee() {
      this.bAssignToEmployee = false;
    },
    setJobcardWorkflowEmployee() {
      if (this.newWorkflowEmployeeId <= 0) {
        this.bShowWarning = true;
        return;
      }
      axios.post('/Om/SetJobcardWorkflowEmployee',
        {
          ObjectId: this.jobcardData.id,
          EmployeeId: this.newWorkflowEmployeeId,
          Comment: this.newComment
        })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.NewEmployeeAssignedSuccess'), 2);
            this.bAssignToEmployee = false;
            this.jobcardData.workflowEmployeeId = this.newWorkflowEmployeeId;
            this.jobcardData.assignedEmployee = this.jobcardData.workflowEmployeeId > 0 ? this.getAssignedWorkflowEmployeeText() : 'Unknown';
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch((e) => {
          console.log('setJobcardWorkflowEmployee');
          console.log(e);
          this.$alertMsg(e.message)
        })
    },
    getAssignedWorkflowEmployeeText() {
      var assignedEmployee = this.workflowEmployees.filter(t => t.id == this.jobcardData.workflowEmployeeId).length > 0 ? this.workflowEmployees.filter(t => t.id == this.jobcardData.workflowEmployeeId)[0] : null;
      return assignedEmployee !== null? assignedEmployee.name : 'Unknown Employee';
    },
    setJobcardLocation() {

      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };
      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => { this.geoLocation = pos; },
        (err) => { this.$alertMsg(err.message); },
        geoOptions
      );

      var parameter = {
        ObjectId: this.jobcardData.id ? this.jobcardData.id: -1,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0
      };
      if (this.geoLocation != null) {
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Om/SetJobcardLocation', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.jobcardData.bHasLocation = true;
            this.bHasLocation = true;
            this.$alertMsg(this.$t('messages.JobcardLocationSetSuccess'), 2);
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
          //loader.hide();
        })
        .catch(e => {
          //loader.hide();
          console.log('setJobcardLocation');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
        })
    },
    getProfileDetails() {
      axios.post('/account/GetProfileDetails')
        .then(response => {
          //add flag for field worker user
          //this.user['isFieldWorker'] = response.data.item.isFieldWorker;

          if (response.data.data.status == 0)
            this.bPortalGis = (response.data.item.portalGis && response.data.item.portalGis == true) ? true : false;
        })
        .catch(e => {
          console.log('getProfileDetails');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
        })
    },
    getOmUseHoursForDuration() {
      axios.post('/Utility/GetOmUseHoursForDuration')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bHoursForDuration = response.data.value;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getOmUseHoursForDuration');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    formatDateUI(date) {
      return moment(date).add(1, 'days').format(uiDateFormat);
    },
    formatDateYYYYMMDD(date) {
      return moment(date, 'YYYY-MM-DD'); //.format();
    },
    getStations() {
      axios.post('/Om/GetStations')
        .then(response => {
          if (response.data.data.status == 0) {
            this.stations = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getStations');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    getJobcardReports() {
      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.get('/Om/GetJobcardReports')
        .then(response => {
          var items = response.data.items;
          if (items.length > 1)
            items.unshift({ reportId: -1, description: 'Select report' });
          this.reports = items;
          if (this.reports.length > 0)
            this.selectedReportId = this.reports[0].reportId;
          //loader.hide();
        })
        .catch(e => {
          //loader.hide();
          console.log('getJobcardReports');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    createJobcardReport() {
      if (this.selectedReportId > 0) {
        var parameters = { ReportId: this.selectedReportId, ObjectId: this.jobcardData.id };
        //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
        axios.post('/Om/CreateJobcardReport', parameters)
          .then(response => {
            if (response.data.data.status == 0) {
              var url = response.data.url;
              window.open(url, '_blank');
            }
            else
              this.$alertMsg(response.data.data.text, 1)
            //loader.hide();
          })
          .catch(e => {
            //loader.hide();
            console.log('createJobcardReport');
            console.log(e);
            this.$alertMsg(e.message, 1)
          })
      }
    },
    getMaintenanceActivities() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetMaintenanceActivities', { Value: this.jobcardData.complainTypeId }),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            this.maintenanceActivities = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        },
        err => {
          console.log('createJobcardReport');
          console.log(err);
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Details'
      );
    },
    getElement() {
      axios.post('/Om/GetElement', { TypeId: this.jobcardData.elementTypeId, Id: this.jobcardData.elementId })
        .then(response => {
          if (response.status == 200) {
            this.element = response.data.item;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getElement');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    getElements() {
      var parameter = {
        FilterByCurrentLocation: false,
        ElementTypeId: this.jobcardData.elementTypeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: this.options
      };
      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.status == 200) {
            this.elements = response.data.items;
            this.options.count = response.data.count;
            var element = this.elements.filter(t => t.id === this.jobcardData.elementId)[0];
            if (element)
              this.value = element.name;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getElements');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    getGisLayerName() {
      var res = this.elementTypes.filter(t => t.typeId == this.jobcardData.elementTypeId);
      return (res.length == 1) ? res[0].gisLayerName : "";
    },
    getElementTypes() {
      this.elementTypes = this.$store.state.elementTypesPlain;
      /*axios.get('/Element/GetElementTypesPlain')
        .then(response => {
          if (response.status == 200) {
            this.elementTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data)
          }
        })
        .catch(e => {
          console.log('getElementTypes');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })*/
    },
    getElementTypeConditions() {
      axios.post('/Om/GetElementTypeConditions', { Value: this.jobcardData.elementTypeId })
        .then(response => {
          if (response.data.data.status == 0) {
            this.elementTypeConditions = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getElementTypeConditions');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    getComplainTypes() {
      axios.post('/Om/GetComplainTypes')
        .then(response => {
          if (response.data.data.status == 0) {
            this.complainTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getComplainTypes');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    getOutcomes() {
      axios.post('/Om/GetJobcardOutcomes')
        .then(response => {
          if (response.status == 200) {
            this.outcomes = response.data.items.filter(t => t.id !== 5);
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getOutcomes');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    getWorkflowEmployees() {
      axios.post('/Om/GetWorkflowEmployees', { Value: this.newStationId })
        .then(response => {
          if (response.data.data.status == 0) {
            this.workflowEmployees = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getWorkflowEmployees');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    getElementFromQR(qrElementId) {
      axios.post('/Om/GetElement', { TypeId: this.jobcardData.elementTypeId, Id: qrElementId })
        .then(response => {
          if (response.data.data.status == 0) {
            this.element = response.data.item;
            this.$alertMsg(this.$t('messages.QRCodeElementSetSuccess'), 2);
          }
          else {
            this.$alertMsg(this.$t('messages.QRCodeElementFailure'))
          }
        })
        .catch(e => {
          console.log('getElementFromQR');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
    onDecode(content) {
      this.bQrCodeScan = false;
      this.getElementFromQR(parseInt(content));
    },
    onInit(promise) {
      promise.then(() => {
        console.log('QR Reader Successfully initilized! Ready for scanning now!')
      })
        .catch(error => {
          if (error.name === 'NotAllowedError') {
            this.errorMessage = 'Hey! I need access to your camera'
          } else if (error.name === 'NotFoundError') {
            this.errorMessage = 'Do you even have a camera on your device?'
          } else if (error.name === 'NotSupportedError') {
            this.errorMessage = 'Seems like this page is served in non-secure context (HTTPS, localhost or file://)'
          } else if (error.name === 'NotReadableError') {
            this.errorMessage = 'Couldn\'t access your camera. Is it already in use?'
          } else if (error.name === 'OverconstrainedError') {
            this.errorMessage = 'Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?'
          } else {
            this.errorMessage = 'UNKNOWN ERROR: ' + error.message
          }
        })
    },
    zoomToElement() {
      axios.post('/GIS/GetZoomToElementUrl', { ElementType: this.element.typeId, ElementId: this.element.id })
        .then(response => {
          if (response.data.data.status == 0) {
            var url = response.data.url;
            window.open(url, '_blank');
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('zoomToElement');
          console.log(e);
          this.$alertMsg(e.message)
          this.$router.push('/login');
          return false;
        })
    },
  }

}
